import { Map, fromJS } from 'immutable';
import Actions from 'flow/actions';
import { getTopQueueCallWithNumbersInE164Format } from 'flow/utils/pbx-utils';

const initialState = Map({
    mexuserToEntityKey: Map(),
    prefixToEntityKey: Map(),
    uniqueIdToEntityKey: Map(),
    anumberToEntityKey: Map(),
    isSyncing: false,
});

const parsePrefixFromChannel = (channel) => {
    const sipMatch = /^(SIP\/[a-z0-9]+)/.exec(channel);
    const bridgeMatch = /^Bridge\/(SIP\/[a-z0-9]+)/.exec(channel);
    const localMatch = /^(Local\/[a-z0-9]+)/.exec(channel);
    if (sipMatch) {
        return sipMatch[1];
    } else if (bridgeMatch) {
        return bridgeMatch[1];
    } else if (localMatch) {
        return localMatch[1];
    }
    return undefined;
};

/**
 * Build mappings between Top and internal storage by mapping channel names,
 * and mexusers to an entitykey - and then being able to map uniqueids to
 * entitykeys in turn.
 */
const topReducer = (state = initialState, action) => {
    switch (action && action.type) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }

        case Actions.RESULT_TOP_SYNC_START: {
            return state.set('isSyncing', true);
        }

        case Actions.RESULT_TOP_SYNC_STOP: {
            return state.set('isSyncing', false);
        }

        case Actions.RESULT_TOP_EXTENSION: {
            const { EntityKey, Anumber, Name, MexUser } = action.data;

            const LocalName = 'Local/' + Anumber;
            const state1 = state
                .setIn(['anumberToEntityKey', Anumber], EntityKey)
                .setIn(['prefixToEntityKey', Name], EntityKey)
                .setIn(['prefixToEntityKey', LocalName], EntityKey);

            if (MexUser) {
                return state1.setIn(['mexuserToEntityKey', MexUser], EntityKey);
            } else {
                return state1;
            }
        }

        case Actions.UPDATE_TOP_CHANNEL: {
            const data = getTopQueueCallWithNumbersInE164Format(action.channel);
            const immutableData = fromJS(data);

            return state.mergeIn(
                ['uniqueIdToChannel', action.channelID],
                immutableData,
            );
        }

        case Actions.RESULT_TOP_NEW_CHANNEL: {
            const { Channel, UniqueID } = action.data;

            if (!state.hasIn(['uniqueIdToEntityKey', UniqueID])) {
                const prefix = parsePrefixFromChannel(Channel);
                if (prefix) {
                    const entityKey = state.getIn([
                        'prefixToEntityKey',
                        prefix,
                    ]);
                    return state.setIn(
                        ['uniqueIdToEntityKey', UniqueID],
                        entityKey,
                    );
                }
            }
            return state;
        }

        case Actions.RESULT_TOP_NEW_MEX_CHANNEL: {
            const { MexUser, UniqueID } = action.data;
            const entityKey = state.getIn(['mexuserToEntityKey', MexUser]);

            return state.setIn(['uniqueIdToEntityKey', UniqueID], entityKey);
        }

        case Actions.RESULT_TOP_HANGUP_CHANNEL: {
            const { UniqueID } = action.data;

            return state
                .deleteIn(['uniqueIdToEntityKey', UniqueID])
                .deleteIn(['uniqueIdToChannel', UniqueID]);
        }

        case Actions.RESULT_EXTENSION: {
            const extensionData = fromJS(action.data);
            const activeCalls = extensionData.get('activeCalls');

            if (!activeCalls) {
                return state;
            }

            return state.mergeIn(
                ['uniqueIdToEntityKey'],
                activeCalls.reduce(
                    (result, call) =>
                        result.set(
                            call.get('key').replace('activecall-', ''),
                            action.key,
                        ),
                    Map(),
                ),
            );
        }

        default: {
            return state;
        }
    }
};

export default topReducer;
